// extracted by mini-css-extract-plugin
module.exports = {"afterHoursPriceContainer":"afterHoursPrice_afterHoursPriceContainer__Yd5oQ","change":"afterHoursPrice_change__3nlAW","afterHoursText":"afterHoursPrice_afterHoursText__efOFE"};